import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { isNullOrUndefined } from 'util';
import { ChartConstants } from './chart-constants';
import Exporting from 'highcharts/modules/exporting';
import { style } from '@angular/animations';

declare var require: any;
const Boost = require('highcharts/modules/boost');
const noData = require('highcharts/modules/no-data-to-display');
const More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);
// Exporting(Highcharts);

class PieObject {
  name: string;
  y: number;
  color: string;
  size: string;
  innerSize: string;
  sliced: boolean;
}

class BarObject {
  name: any;
  data: any[] = [];
  color: any;
}

class LineObject {
  name: any;
  data: any[] = [];
  color: any;
}

class BoxPlotOutlierObject {
  name: any;
  color: string;
  type: string;
  data: any[] = [];
  marker: object = {};
  tooltip: object = {};
  fillColor: string;
  opacity: number;
}

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})

export class ChartComponent implements OnInit, OnChanges {

  constructor(private router: Router) { }

  @Input() chartConfig: any;
  @Input() chartConfig2: any;
  @Input() id: string;
  @Input() chartData: any[];
  @Input() chartData2: object;
  @Input() ensmblData: boolean;
  @Input() plotBandData: object;
  @Input() currentPlayPosition: any;
  chart: any;
  @ViewChild('chart', {
    read: ElementRef,
    static: true
  }) chartId: ElementRef;

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    this.chartId.nativeElement.id = this.id;
    if (this.id == 'chart10') {
      this.setBarChart(this.chartConfig2, this.chartData2);
    } else {
      this.setChart(this.chartConfig2, this.chartData2);
    }

    this.chart.width = '100%';
    this.chart.chart['backgroundColor'] = '#151C26';
    if (this.ensmblData === true) {
      this.chart.chart['plotBackgroundColor'] = '#ffffff';
    }
    this.chart.yAxis['gridLineColor'] = 'rgba(255,255,255,0.5)';
    this.chart.yAxis['gridLineWidth'] = 0.5;
    if (this.id !== 'chart10') {
      this.chart.legend['itemStyle'] = {
        color: '#FFFFFF'
      };
    }
    this.chart.xAxis['labels'] = {
      style: {
        color: '#FFFFFF'
      }
    };
    this.chart.yAxis['labels'] = {
      style: {
        color: '#FFFFFF'
      }
    };
    if (!isNullOrUndefined(this.chart.yAxis['title'])) {
      this.chart.yAxis['title']['style'] = {
        color: '#FFFFFF'
      };
    }

    // To Make sure that tickIntercal does not apply to percentage based charts
    if (this.id == 'chart10') {
      this.chart.chart['backgroundColor'] = null;
      this.chart.xAxis.labels = {
        formatter: function () {
          const len = 5;
          if (this.value.length > len) {
            return this.value.slice(0, len) + '...';
          } else {
            return this.value;
          }
        },
        style: {
          color: '#ffffff'
        }
      };
    }
    if (this.id == 'landingChartFlowForecast' || this.id == 'landingChartRainFall' || this.id == 'landingChartWindSpeed' || this.id == 'landingChartHeatWatch') {
      this.chart.chart['backgroundColor'] = null;
      // this.chart.legend.itemStyle.fontSize = '10px'
      this.chart.exporting = { enabled: false };
      this.chart.legend.useHTML = true;
      if (this.id == 'landingChartFlowForecast') {
        this.chart.yAxis.labels.format = '{value}%';
        this.chart.tooltip = { pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}%</b><br/>', backgroundColor: '#FCFFC5' };
        // this.chart.yAxis.endOnTick = false;
        this.chart.yAxis.tickPositioner = function () {
          if (this.dataMax >= 100) {
            return [0, 50, 100];
          } else {
            return [this.min, this.dataMax.toFixed(2)];
          }
        };
        this.chart.xAxis.labels = {
          formatter: function () {
            const len = 5;
            if (this.value.length > len) {
              return this.value.slice(0, len) + '...';
            } else {
              return this.value;
            }
          },
          style: {
            color: 'white'
          }
        };
      }
      if (this.id != 'landingChartFlowForecast') {
        this.chart.yAxis.tickInterval = 250;
        this.chart.yAxis.tickPositioner = function () {
          if (this.dataMax === 670) {
            return [0, 250, 500, 750];
          } else {
            this.chart.yAxis.tickInterval = (this.dataMax / 4) + 1;
            return [this.min, Math.floor(this.dataMax / 2), Math.ceil(this.dataMax)];
          }
        };
      }
      // else if(this.chart.plotOptions.column.stacking && this.chart.plotOptions.column.stacking === 'percent'){
      //   // this.chart.yAxis.tickInterval = 50;
      //   this.chart.yAxis.tickPositioner = function() {
      //     if(this.dataMax === 100){
      //       return [0,50,100]
      //     }
      //     else{
      //       return [this.min,43]
      //     }
      //   }
      //   this.chart.yAxis.labels.format='{value}%'
      //   this.chart.tooltip = {pointFormat:'<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}%</b><br/>', backgroundColor: '#FCFFC5'}
      // }
    }
    Highcharts.chart(this.id, this.chart);
  }

  private setChart(chartConstant: ChartConstants, chartData) {
    // console.log(chartConstant,"chart configs",chartData);
    
    this.chart = {
      chart: {},
      title: {},
      subtitle: {},
      tooltips: {},
      colors: [],
      xAxis: {},
      yAxis: {},
      plotOptions: {},
      credits: {},
      legend: {},
      series: [],
      responsive: {},
    };
    if (!chartConstant || !chartData) {
      return {};
    }

    this.insertChartTitle(chartConstant.chartTitle, this.ensmblData);
    if (!chartConstant.datakeys || chartConstant.datakeys.length === 0) {
      chartConstant.datakeys = this.getDataKeysFromData(chartData);
    }
    if (chartConstant.stacking) {
      this.chart.plotOptions = {
        series: {
          stacking: chartConstant.stacking
        }
      };
    }
    if (chartConstant.plotOptions) {
      this.chart.plotOptions = chartConstant.plotOptions;
    }


    this.chart.tooltip = chartConstant.tooltips ? chartConstant.tooltips : {};
    this.chart.datalabels = chartConstant.datalabels ? chartConstant.datalabels : {};
    this.chart.legend = chartConstant.legend ? chartConstant.legend : {};
    this.chart.credits = {
      enabled: false
    };
    if (chartConstant.chartType === 'boxplot') {
      this.formatterForBlockChart(chartConstant, chartData);
      this.chart.colors.push('#000000');
      this.chart.chart.height = 600;
      const categories = [];
      Object.keys(chartData).forEach(key => categories.push(chartData[key]['locName']));
      this.chart.xAxis['labels'] = {
        style: {
          color: '#FFFFFF'
        }
      };
      this.chart.xAxis.categories = categories;
    } else if (chartConstant.chartType === 'donut' || chartConstant.chartType === 'pie') {
      if (this.id == 'landingChartRainFall' || this.id == 'landingChartWindSpeed') {
        this.getDonutChartForUnified(chartConstant, chartData)
      } else {
        this.formatterForPieAndDonutChart(chartConstant, chartData);
      }
    } else {
      this.chart.xAxis = this.insertxAxisFromConfig(chartConstant.xAxis, chartConstant);
      
      const len = Object.keys(chartConstant['xAxisLabel']).length;
      if (len <= 12) {
        this.chart.plotOptions['series']['pointWidth'] = 16;
      } else if (len > 12 && len <= 16) {
        this.chart.plotOptions['series']['pointWidth'] = 10;
      } else if (len >= 17 && len <= 23) {
        this.chart.plotOptions['series']['pointWidth'] = 5;
      } else {
        this.chart.plotOptions['series']['pointWidth'] = 3;
      }
      this.formatterForChartOtherThanPieAndDonut(chartConstant, chartData, this.chart.xAxis.categories);
    }
  }

  private setXAxisLabel(chartConfig: ChartConstants) {
    for (const index in this.chart['xAxis'].categories) {
      this.chart['xAxis'].categories[index] = chartConfig.xAxisLabel[this.chart['xAxis'].categories[index]];
    }
  }

  private getRandomColor() {
    const color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  private getDataKeysFromData(chartData) {

    const datakeys = [];
    for (const key of Object.keys(chartData)) {
      datakeys.push(key);
    }

    return datakeys;
  }

  private insertxAxisFromConfig(xAxis: string[], chartConfig) {
    if (!xAxis) {
      xAxis = this.getXAxisFromConfig(chartConfig);
    }
    const xAxisObject = {
      categories: xAxis
    };
    return xAxisObject;

  }

  private getXAxisFromConfig(chartConfig) {
    const xAxis: string[] = [];
    if (chartConfig != undefined && chartConfig['xAxisLabel'] != undefined) {
      for (const key of Object.keys(chartConfig['xAxisLabel'])) {
        xAxis.push(key);
      }
    }
    return xAxis;
  }

  private insertxAxis(xAxis: string[], chartData) {
    if (!xAxis) {
      xAxis = this.getXAxisFromData(chartData);
    }
    const xAxisObject = {
      categories: xAxis
    };
    return xAxisObject;

  }

  private getXAxisFromData(chartData) {
    const xAxis: string[] = [];
    for (const key of Object.keys(chartData)) {
      for (const xaxis of Object.keys(chartData[key])) {
        xAxis.push(xaxis);
      }
      break;
    }
    return xAxis;
  }

  private insertChartTitle(chartTitle, param) {
    // if(chartTitle){
    //               this.chart['title']['text'] = ''; // chartTitle;
    //             }
    // else{
    // this.chart['title']['text'] = '';
    if (param === true || this.router.url.split('/')[1] == 'cyclone') {
      this.chart.title.text = chartTitle;
    } else {
      this.chart.title.text = '';
    }
    this.chart.title.style = { color: '#ffffff', fontSize: '14px' };
    // }
  }

  private formatterForPieAndDonutChart(chartConstant: ChartConstants, chartData) {
    const seriesdata = [];
    this.chart.chart = {
      type: 'pie'
    };

    for (const keys of Object.keys(chartData)) {
      for (const key2 of Object.keys(chartData[keys])) {
        const obj = new PieObject();
        obj.name = (chartConstant.labels && chartConstant.labels[key2]) ? chartConstant.labels[key2] : key2;
        obj.y = chartData[keys][key2];
        if (chartConstant.colors && chartConstant.colors[key2]) {
          obj.color = chartConstant.colors[key2];
        } else {
          obj.color = this.getRandomColor();
        }
        if (chartConstant.chartType == 'donut') {
          obj.size = chartConstant.size;
          obj.innerSize = chartConstant.innersize;
        }
        if (chartConstant.sliced && chartConstant.sliced[key2]) {
          obj.sliced = chartConstant.sliced[key2];
        }
        seriesdata.push(obj);
      }
    }
    this.chart.series.push({
      data: seriesdata
    });
  }

  private formatterForChartOtherThanPieAndDonut(chartConstant: ChartConstants, chartData, xAxis) {
    this.chart.chart = {
      type: chartConstant.chartType
    };
    // console.log("chartData1",chartConstant,chartData)
    for (const keys of Object.keys(chartData)) {
      const seriesObject = new LineObject();
      if (chartConstant.labels) {

      }

      seriesObject.name = (chartConstant.labels && chartConstant.labels[keys]) ? chartConstant.labels[keys] : keys;
      if (chartConstant.colors && chartConstant.colors[keys]) {
        seriesObject.color = chartConstant.colors[keys];
      } else {
        seriesObject.color = this.getRandomColor();
      }
      for (const key2 of xAxis) {
        seriesObject.data.push(chartData[keys][key2]);
      }
      this.chart.series.push(seriesObject);
    }
    if (chartConstant.yAxisLabels) {

      this.chart.yAxis = {
        title: {
          text: chartConstant.yAxisTitle
        },
        labels: chartConstant.yAxisLabels.labels
      };
    } else {

      this.chart.yAxis = {
        title: {
          text: chartConstant.yAxisTitle
        },
      };
    }

    if (chartConstant.xAxisLabel) {
      this.setXAxisLabel(chartConstant);
    }
    // console.log("chart", this.chart)
  }

  private formatterForBlockChart(chartConstant: ChartConstants, chartData) {
    let pos: string;
    if (isNullOrUndefined(this.currentPlayPosition)) {
      pos = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 5, 30, 0, 0).getTime().toString();
    } else {
      pos = this.currentPlayPosition;
    }
    const seriesObject = new BoxPlotOutlierObject();
    const seriesObject1 = new BoxPlotOutlierObject();
    const seriesData = [];
    const outliersData = [];
    this.chart.chart = {
      type: chartConstant.chartType
    };
    Object.keys(chartData).forEach(key => {
      const seriesdata = [];
      const data = chartData[key]['ens'][pos];
      seriesdata.push(Math.round((data['min'] + Number.EPSILON) * 100) / 100.0);
      seriesdata.push(Math.round((data['lq'] + Number.EPSILON) * 100) / 100.0);
      seriesdata.push(Math.round((data['med'] + Number.EPSILON) * 100) / 100.0);
      seriesdata.push(Math.round((data['uq'] + Number.EPSILON) * 100) / 100.0);
      seriesdata.push(Math.round((data['max'] + Number.EPSILON) * 100) / 100.0);
      seriesData.push(seriesdata);
      data['det'].forEach(element => {
        outliersData.push([key, Math.round((element + Number.EPSILON) * 100) / 100.0]);
      });
    });
    seriesObject.name = chartConstant.plotOptions['series']['name'];
    seriesObject.data = seriesData;
    seriesObject.tooltip['headerFormat'] = '<em>Observation(in mm)</em><br/>';
    seriesObject.opacity = 0.7;
    this.chart.series.push(seriesObject);
    seriesObject1.name = 'Deterministic Forecast';
    seriesObject1.color = 'red';
    seriesObject1.type = 'scatter';
    seriesObject1.data = outliersData;
    seriesObject1.marker['fillColor'] = 'red';
    seriesObject1.marker['lineWidth'] = 1;
    seriesObject1.marker['lineColor'] = 'red';
    seriesObject1.tooltip['pointFormat'] = 'Actual Value : {point.y}';
    this.chart.series.push(seriesObject1);

    if (chartConstant.yAxisLabels) {
      this.chart.yAxis = {
        max: 750,
        ceiling: 750,
        title: {
          text: chartConstant.yAxisTitle
        },
        labels: chartConstant.yAxisLabels.labels
      };
    } else {
      this.chart.yAxis = {
        title: {
          text: chartConstant.yAxisTitle
        },
      };
    }

    if (this.plotBandData) {
      this.chart.yAxis.plotBands = this.setPlotBand();
    }
  }

  setPlotBand() {
    const plotbandData = [];
    Object.keys(this.plotBandData).forEach(key => {
      const data = this.plotBandData[key];
      plotbandData.push({
        from: data['from'],
        to: data['to'],
        color: data['color'],
        label: {
          text: key
        }
      });
    });
    return plotbandData;
  }

  setBarChart(chartConstant: ChartConstants, chartData) {
    this.chart = {
      chart: {},
      exporting: {},
      title: {},
      tooltip: {},
      colors: [],
      credits: {},
      xAxis: {},
      yAxis: {},
      plotOptions: {},
      series: [],
    };

    this.chart.chart = {
      type: 'column',
      // height: 230
    };

    this.chart.exporting = {
      enabled: false
    };

    this.chart.credits = {
      enabled: false
    };

    this.chart.title.text = null;
    this.chart.title.style = { color: '#ffffff', fontSize: '14px' };
    this.chart.colors = ['red'];

    let xAxisTemp = [], seriesData = [], devData = {}, count = 0, xAxistp = {},normalData = {};
    Object.keys(chartData).forEach(ele => {
      if (ele) {
        xAxisTemp.push(ele);
        let color;
        if(chartData[ele]['deviation'] > -25 && chartData[ele]['deviation']<25){
          color = "#003288"
        }else if(chartData[ele]['deviation'] > 25){
          color = "#00ff00"
        }else if(chartData[ele]['deviation'] < -25){
          color = "#ff0000"
        }
        // if (chartData[ele]['actual'] < chartData[ele]['normal']) {
        //   color = '#b22222';
        // } else {
        //   color = '#32cd32';
        // }
        const obj = { name: ele, y: chartData[ele]['actual'], color };
        seriesData.push(obj);
        xAxistp[count] = ele;
        count++;
        devData[ele] = chartData[ele]['deviation'];
        normalData[ele] = chartData[ele]['normal']
      }
    });
    this.chart.xAxis = {
      type: 'category',
      title: {
        text: null
      }
    };

    this.chart.tooltip = chartConstant.tooltips ? chartConstant.tooltips : {};
    this.chart.tooltip = {
      formatter: function () {
        return '<span style="font-size:12px">' + xAxistp[this.x] + '</span><table>' +
          '<tr><td>Actual: </td>' +
          '<td style="padding:0"><b>' + this.y + 'mm</b></td></tr>' +
          '<tr><td>Normal: </td>' +
          '<td style="padding:0"><b>' + normalData[xAxistp[this.x]] + 'mm</b></td></tr>' +
          '<tr><td>Deviation: </td>' +
          '<td style="padding:0"><b>' + devData[xAxistp[this.x]]
          + '%</b></td></tr>' +
          '</table>';
      },
      shared: true,
      useHTML: true,
      backgroundColor: '#FCFFC5',
      // borderColor: 'black',
      borderRadius: 10,
      // borderWidth: 3
    };
    this.chart.yAxis = {
      title: {
        text: chartConstant.yAxisTitle
      },
    };

    if (chartConstant.plotOptions) {
      this.chart.plotOptions = chartConstant.plotOptions;
    }

    this.chart.series = [{
      showInLegend: false,
      colorByPoint: true,
      // name: null,
      data: seriesData
    }];
  }

  private getDonutChartForUnified(chartConstant: ChartConstants, chartData) {
    const seriesdata = [];
    this.chart.chart = {
      type: 'pie'
    };
    this.chart.tooltip = { 
      headerFormat: '',
      pointFormat: '<span style="color:{point.color}">\u25CF</span><b> {point.name} </b>: <b>{point.y}%</b><br/>', 
      backgroundColor: '#FCFFC5' 
    };

    for (const keys of Object.keys(chartData)) {
      for (const key2 of Object.keys(chartData[keys])) {
        const obj = new PieObject();
        if (this.id == 'landingChartRainFall') {
          obj.name = (chartConstant.labels && chartConstant.labels[key2]) ? chartConstant.labels[key2] : keys[0].toUpperCase() + keys.slice(1);
        } else {
          obj.name = (chartConstant.labels && chartConstant.labels[key2]) ? chartConstant.labels[key2] : keys;
        }
        obj.y = chartData[keys][key2];
        if (chartConstant.colors && chartConstant.colors[keys]) {
          obj.color = chartConstant.colors[keys];
        } else {
          obj.color = this.getRandomColor();
        }
        if (chartConstant.chartType == 'donut') {
          obj.size = chartConstant.size;
          obj.innerSize = chartConstant.innersize;
        }
        if (chartConstant.sliced && chartConstant.sliced[key2]) {
          obj.sliced = chartConstant.sliced[key2];
        }
        seriesdata.push(obj);
      }
    }
    this.chart.series.push({
      data: seriesdata
    });
  }

}
